import { Icons } from './Icons';

type Props = {
  onStart: () => void;
  onToggleFullscreen: () => void;
};

export function SplashScreen({ onStart, onToggleFullscreen }: Props) {
  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center overflow-hidden bg-black cursor-pointer"
      onClick={onStart}
    >
      <div className="absolute inset-0 z-0 opacity-70 animate-pan">
        <img
          src="https://images.unsplash.com/photo-1500076656116-558758c991c1?q=80&w=2000&auto=format&fit=crop"
          className="w-full h-full object-cover"
          alt=""
        />
      </div>
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-black via-transparent to-black opacity-80" />
      <div className="splash-content relative z-20 text-center text-white p-8 flex flex-col items-center gap-4 md:gap-6 animate-fade-in-slow">
        <div className="text-green-300 text-sm md:text-lg tracking-[0.5em] uppercase font-bold opacity-80">
          The Legend of
        </div>
        <h1 className="splash-title zelda-font text-5xl md:text-8xl font-black tracking-wider text-transparent bg-clip-text bg-gradient-to-b from-yellow-100 to-yellow-500 drop-shadow-[0_0_15px_rgba(250,204,21,0.6)]">
          農夫搶水果
        </h1>
        <div className="h-px w-16 md:w-24 bg-white/50 my-2 md:my-4" />
        <p className="splash-subtitle text-lg md:text-2xl font-light tracking-widest text-white/90">
          終極豪華版
        </p>
        <div className="mt-8 md:mt-12 animate-glow">
          <span className="text-base md:text-xl border-b border-white/30 pb-1 tracking-widest">
            點擊任意處開始
          </span>
        </div>
        <div className="absolute top-4 right-4 z-30">
          <button
            onClick={(e) => {
              e.stopPropagation();
              onToggleFullscreen();
            }}
            className="text-white/70 hover:text-white p-2 rounded-full hover:bg-white/20 transition"
            title="全螢幕"
          >
            <Icons.Maximize />
          </button>
        </div>
      </div>
    </div>
  );
}
